var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12613 2.28143C10.4801 2.28019 11.8041 2.68057 12.9305 3.43193C14.057 4.18328 14.9352 5.25184 15.4543 6.50244C15.9733 7.75303 16.1097 9.12947 15.8463 10.4576C15.5829 11.7858 14.9315 13.006 13.9745 13.9638C13.0175 14.9217 11.7979 15.5742 10.47 15.8388C9.1421 16.1035 7.76554 15.9683 6.51447 15.4504C5.2634 14.9325 4.19404 14.0552 3.44166 12.9295C2.68927 11.8037 2.28768 10.4801 2.28768 9.12612C2.29589 7.31441 3.01881 5.57914 4.29931 4.29747C5.57981 3.01579 7.31442 2.29129 9.12613 2.28143ZM9.12613 1C7.51893 1 5.94783 1.47659 4.61149 2.3695C3.27516 3.26241 2.23362 4.53154 1.61857 6.01639C1.00352 7.50125 0.842597 9.13514 1.15614 10.7115C1.46969 12.2878 2.24363 13.7357 3.38009 14.8722C4.51655 16.0086 5.96449 16.7826 7.5408 17.0961C9.11711 17.4097 10.751 17.2487 12.2359 16.6337C13.7207 16.0186 14.9898 14.9771 15.8828 13.6408C16.7757 12.3044 17.2523 10.7333 17.2523 9.12612C17.2523 6.97094 16.3961 4.90403 14.8722 3.38009C13.3482 1.85614 11.2813 1 9.12613 1Z",
    fill: "#212121",
    stroke: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7965 19.934L16.1896 15.2959L15.302 16.1773L19.9089 20.8154C19.9668 20.8737 20.0356 20.92 20.1113 20.9517C20.1871 20.9834 20.2684 20.9999 20.3505 21.0002C20.4326 21.0005 20.514 20.9846 20.59 20.9534C20.666 20.9222 20.7351 20.8764 20.7934 20.8185C20.8517 20.7607 20.898 20.6919 20.9297 20.6161C20.9614 20.5403 20.9779 20.4591 20.9782 20.3769C20.9785 20.2948 20.9626 20.2134 20.9314 20.1374C20.9002 20.0614 20.8544 19.9923 20.7965 19.934Z",
    fill: "#212121",
    stroke: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.7e5c97788a50156634f2ad8d87e2b00f.svg";
export { ForwardRef as ReactComponent };